import Vue from 'vue'

Vue.component('search-form', {
  props: [
    'resultsCount'
  ],
  data: () => { 
    return { 
      searchText: '',
      inMap: false
    } 
  },
  template: `
  <div class="filter-box">
    <input type="text" @keyup="findArea" v-model="searchText">
    <button @click="findArea">Filter</button>
    <label v-if="false">Only visible
      <input v-model="inMap" @change="findArea" type="checkbox"/>
    </label>
    <span>
    {{resultsCount}}
    area<span v-if="resultsCount!==1">s</span>
    </span>
   </div>
  `,
  methods: {
    findArea: function(e) { 
      this.$emit('search', this.searchText, this.inMap);
    }
  }
})

